import { useMemo, useState } from 'react';

export const useSidebarContent = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isSdkLinkShow, setSdkLinkShow] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isIframeSidebarOpen, setIframeSidebarOpen] = useState(false);
  const [isIframeAnimating, setIsIframeAnimating] = useState(false);

  return useMemo(
    () => ({
      isDropdownOpen,
      setDropdownOpen,
      isSdkLinkShow,
      setSdkLinkShow,
      isAnimating,
      setIsAnimating,
      isIframeSidebarOpen,
      setIframeSidebarOpen,
      isIframeAnimating,
      setIsIframeAnimating,
    }),
    [isDropdownOpen, isSdkLinkShow, isAnimating, isIframeSidebarOpen, isIframeAnimating]
  );
};
